import util from '../util'

let controller = 'ParceiroOperacaoComissaoPeriodo'
export default Object.assign({}, util.GetCrud(controller, null))
